import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message = "Loading..." }: LoadingStateProps) {
  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        minHeight: 240,
        py: 8,
        color: "text.secondary",
      }}
    >
      <CircularProgress size={32} color="inherit" />
      <Typography variant="body2">{message}</Typography>
    </Stack>
  );
}
